($ => {

    if($('.js-Tippy').length > 0){
        tippy('.js-Tippy', {
            arrow: true,
            animation: 'scale',
            inertia: true
        })
    }

})(jQuery)
